import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../context/AuthContext';
import { subscriptionQueryKey } from './useSubscription';
import { referralQueryKey } from './useReferral';

export const useCacheSync = () => {
  const queryClient = useQueryClient();
  const { token, profile } = useAuth();

  useEffect(() => {
    if (!token || !profile) return;

    console.log('🔄 Cache sync initialized with browser-based updates');

    // Обработчик для обновления кеша при возврате на вкладку
    const handleVisibilityChange = () => {
      if (!document.hidden && token) {
        // Пользователь вернулся на вкладку - обновляем кеш
        queryClient.invalidateQueries({ 
          queryKey: subscriptionQueryKey(token) 
        });
        queryClient.invalidateQueries({ 
          queryKey: referralQueryKey(token) 
        });
        console.log('🔄 Cache refreshed due to tab visibility change');
      }
    };

    // Обработчик для обновления кеша при восстановлении сети
    const handleOnlineChange = () => {
      if (navigator.onLine && token) {
        // Интернет восстановился - обновляем кеш
        queryClient.invalidateQueries({ 
          queryKey: subscriptionQueryKey(token) 
        });
        queryClient.invalidateQueries({ 
          queryKey: referralQueryKey(token) 
        });
        console.log('🔄 Cache refreshed due to network reconnection');
      }
    };

    // Подписываемся на события
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('online', handleOnlineChange);

    // Cleanup при размонтировании
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('online', handleOnlineChange);
      console.log('🔄 Cache sync cleaned up');
    };
  }, [token, profile, queryClient]);

  // Функция для ручного обновления всех кешей
  const invalidateAllCaches = () => {
    if (!token) return;
    
    queryClient.invalidateQueries({ 
      queryKey: subscriptionQueryKey(token) 
    });
    queryClient.invalidateQueries({ 
      queryKey: referralQueryKey(token) 
    });
    console.log('🔄 All caches manually invalidated');
  };

  return { invalidateAllCaches };
}; 